module.exports = __webpack_public_path__ + "img/followStar.21f101fa.svg";